import { SOCKET_URL, SOCKET_STATION } from './routes';

export default {
  subscribe(entity, action, callback, {station, backlog}) {
    const sock = window.Q.connect(station || SOCKET_STATION, SOCKET_URL);
    const playsSub = sock.subscribe(entity);
    playsSub.on(action, callback, { backlog });
    return playsSub;
  }
}
